// src/components/dashboard/columns.ts
import type { ColumnsType } from 'antd/es/table';
import { HighchartsSparkline } from './SparklineChart';
import { SourceHealthCell } from './SourceHealthCell';
import SourcesList from './SourcesList';
import { InfrastructureHealth, SourceHealth } from '@/domain/Health/HealthTypes';

export const columns: ColumnsType<InfrastructureHealth> = [
	{
		title: 'Parameter',
		dataIndex: 'parameterName',
		key: 'parameterName',
		width: 100,
	},
	{
		title: 'Parameter Type',
		dataIndex: 'parameterTypeName',
		key: 'parameterTypeName',
		width: 120,
		sorter: (a, b) => a.parameterTypeName.localeCompare(b.parameterTypeName),
	},
	{
		title: 'Location',
		dataIndex: 'locationName',
		key: 'locationName',
		width: 120,
		sorter: (a, b) => a.locationName.localeCompare(b.locationName),
	},
	{
		title: 'Asset',
		dataIndex: 'infrastructureName',
		key: 'infrastructureName',
		width: 120,
		sorter: (a, b) => a.infrastructureName.localeCompare(b.infrastructureName),
	},
	{
		title: 'Asset Type',
		dataIndex: 'infrastructureType',
		key: 'infrastructureType',
		width: 140,
	},
	{
		title: 'Sources',
		dataIndex: 'sources',
		key: 'sources',
		width: 200,
		render: (sources: SourceHealth[]) => {
			return <SourcesList sources={sources} />;
		},
	},
	{
		title: 'Source Health',
		dataIndex: 'sourceHealth',
		key: 'sourceHealth',
		width: 150,
		render: (health: number) => {
			return <SourceHealthCell health={health} />;
		},
	},
	{
		title: 'Sources Values',
		dataIndex: 'sources',
		key: 'sources',
		width: 140,
		render: (sources: SourceHealth[], allInfrastructureData: InfrastructureHealth) => {
			return <HighchartsSparkline sources={sources} unit={allInfrastructureData.unit} />;
		},
	},
];
